
define(
		'eteration/widgets/ui-etrselect',[ 'jquery','knockout', 'eteration/widgets/widget-util','bootstrap.select' ],
		function($,ko, widgetUtil) {
			widgetUtil.setupStringBasedTemplate(ko);


			ko.bindingHandlers.dropdownselect = {
					init : function(element) {
						$(element).attr('data-width','100%');

						
						setTimeout(function() {
							$(element).selectpicker();
							$('.dropdownselect').each(function() {
								$(this).find('button').attr('aria-expanded', false);
							});
						}, 1000);
						
						
						
						$('.signin-container .dropdown-menu .dropdownselect').on('click', function () {
							  return false;
							});
						$('.signin-container .dropdown-menu .dropdownselect button').on('click', function () {
							  if ($(this).next().css('display') == 'none') {
							    $(this).next().show();
							  } else if ($(this).next().css('display') == 'block' && $(this).next().hasClass('open')) {
							    $(this).next().removeClass('open');
							  } else {
							    $(this).next().addClass('open');
							  }
						});
						$('.signin-container .dropdown-menu .dropdownselect .dropdown-menu.open').on('click', function () {
							  $(this).removeClass('open');
						});
						
						$('.signin-container form').on('click', function () {
							  var _a = $('.signin-container .dropdown-menu .dropdownselect .dropdown-menu');
							  if (_a.css('display') == 'block' && _a.hasClass('open')) {
							    _a.removeClass('open');
							  }
						});

						
						
						
					},

					update : function(element, valueAccessor, allBindingsAccessor) {
						
						if(allBindingsAccessor().options && allBindingsAccessor().options.subscribe){
						
							allBindingsAccessor().options.subscribe(function() {
								setTimeout(function() {
									$(element).selectpicker("refresh");
								}, 0); // to handle race condition
								
							}, null, "arrayChange");
							
						}
					}

			};
			
			
			
			
			ko.bindingHandlers.etrselectbasic = {
					init : function(element) {
						$(element).selectpicker({});
					}
			};
			
			ko.bindingHandlers.etrselect = {
				init : function(element, valueAccessor, allBindingsAccessor) {
					var liveSearch = false;
					if (valueAccessor())
						liveSearch = ko.utils.unwrapObservable(valueAccessor()).liveSearch;
					if (typeof liveSearch == 'undefined')
						liveSearch = false;
					$(element).selectpicker({
						showSubtext : true,
						liveSearch : liveSearch,
						dropupAuto : false,
						size : 10
					});
					
					allBindingsAccessor().value.subscribe(function() {
						setTimeout(function() {
							$(element).selectpicker('refresh');
						}, 500);
					});
					
				},

				update : function(element, valueAccessor, allBindingsAccessor) {
					var refresh = true;

					if (valueAccessor())
						refresh = ko.utils.unwrapObservable(valueAccessor()).refresh;

					if (typeof refresh == 'undefined')
						refresh = true;

					if (refresh) {
						//Do not remove, It triggers update function call
						var options = allBindingsAccessor().options();
						var value = allBindingsAccessor().value();
						$(element).selectpicker("refresh");
					}

				}

			};
			
			
		
			
		});